import { DatasetListItem } from '@verantos-dev/types-datasets';

/**
 * Formats dataset release names according to business rules:
 * - If the database prefix (e.g., CDM, BASE) doesn't contain "EXPORT"
 * - And if the releaseId and releaseName don't match (indicating releaseName hasn't been properly populated)
 * - Then, update the releaseName to prefix it with the database as `${db}/${releaseName}`
 *
 * @param releases - Array of dataset releases to format
 * @returns Formatted array of dataset releases
 */
export const formatDatasetReleases = (releases: DatasetListItem[]): DatasetListItem[] => {
  if (!releases || !Array.isArray(releases)) {
    return [];
  }

  return releases.map((release) => {
    const { releaseId, releaseName } = release;

    // Initial check: if releaseId matches releaseName, no need to format
    if (releaseId === releaseName) {
      return release;
    }

    // Extract database prefix from releaseId (characters before the first period)
    const dbMatch = releaseId.match(/^([^.]+)\./);
    if (!dbMatch) {
      return release;
    }

    const dbPrefix = dbMatch[1];

    // Check if the database doesn't contain "EXPORT"
    if (dbPrefix && !dbPrefix.includes('EXPORT')) {
      return {
        ...release,
        releaseName: `${dbPrefix}/${releaseName}`,
      };
    }

    return release;
  });
};
